$(document).ready(function(){
//home page small image slider
$(document).on("mouseover",".itg_card_tab P", function(){
      $(".itg_card_tab P").removeClass('active');
      $(this).addClass('active');
      var value_1 = $(this).attr("DataTab");     
     $(".tab_image").each(function(){
      var value_2 = $(this).attr("DataContent");
       if(value_1 == value_2){
         $(this).addClass("image-active")
       }
       else{
         $(this).removeClass("image-active")
       }
     })
   });
//Announcement bar slider 
  // $('.itg_announcement_bar_slider').slick({
  //   slidesToScroll: 1,
  //   arrows: false,
  //   autoplay:true,
  //   autoplaySpeed:1500,
  //   dots: false,
  //   vertical: true,
  //   verticalSwiping: true
  // });
  var mySwiper = new Swiper ('.itg_announcement_bar_slider', {
    direction: 'vertical',
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
});
   //Featured Collection slider
//   $('.itg_featured_collection_slider').slick({
//   infinite: false,
//   slidesToShow: 3.5,
//   slidesToScroll: 1,
//   dots: false,
//   arrows: true,
//   prevArrow: '<button class="slick-prev pull-left carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
//   nextArrow: '<button class="slick-next pull-right carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
//   responsive: [
//        {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 2.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ] 
// });


  // IMAGE WITH SLIDER
  var swiper = new Swiper(".custom_image_width_slider_head ", {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });

  // CUSTOM MULTICOLUMN
  // var swiper = new Swiper(".custom_multicolumn_head", {
  //   slidesPerView: 3,
  //   spaceBetween: 30,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //       768: {
  //         slidesPerView: 1,         
  //       }
  //     },
  // });

    var swiper = new Swiper(".custom_multicolumn_head", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },    
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        1024:{
          slidesPerView: 3,          
        },
        768: {
          slidesPerView: 2,         
        },
         0: {
          slidesPerView: 1,
        }
      },
    });

  var swiper = new Swiper(".custom_image_with_text_image", {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });
  
  var swiper = new Swiper(".itg_featured_collection_slider", {
      spaceBetween: 0,
      loop: false,
      //freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next.itg-swiper-arrow',
        prevEl: '.swiper-button-prev.itg-swiper-arrow'
      },      
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        1024:{
          slidesPerView: 3.5,          
        },
        768: {
          slidesPerView: 2,         
        },
         480: {
          slidesPerView: 1,
        }
      },
    });
  //collection list section slider
//   $('.itg_collection_slider').slick({
//   infinite: false,
//   slidesToShow: 4.1,
//   slidesToScroll: 1,
//   dots: false,
//   arrows: true,
//   prevArrow: '<button class="slick-prev pull-left carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
//   nextArrow: '<button class="slick-next pull-right carousel-btns slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
//   responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 750,
//         settings: {
//           slidesToShow: 2.1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ] 
// });
var window_width = $(window).width();

  var $swiperSelector = $('.itg_collection_slider.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : true;
    var loop = $this.data('loop') ? $this.data('loop') : false; 

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      allowTouchMove: true,
      freeMode: freeMode,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: 5,
        },
        768:{
          slidesPerView: 3,
          allowTouchMove: true,
        },
        480: {
           slidesPerView: 1.2,
           allowTouchMove: true,
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100
      }
   });
});


//loyalty program slider
var swiper = new Swiper(".itg_loy_slider", {
  //effect: "fade",
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 100
  },
});

//Custom banner slider 
var swiper = new Swiper(".itg_banner_slider", {
  //effect: "fade",
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 100
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});  
  

  $('.itg_megamenu').click(function(){
    $(this).closest('.site-nav__details').removeAttr('open');
  });


if (window.matchMedia("(max-width: 768px)").matches) {
  var swiper = new Swiper(".itg_collection_list", {
      spaceBetween: 10,
      loop: false,
      slidesPerView: 2,
      //freeMode: true,    
      scrollbar: {
        el: '.swiper-scrollbar1',
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        768: {
          slidesPerView: 2        
        }
      }
    });
}


//add class on scroll
$(window).scroll(function() {
  if ($(this).scrollTop() > 200){
    $('.announcement-bar').addClass("itg_fixed");
  } else {
    $('.announcement-bar').removeClass("itg_fixed");
  }
});
});

// $(document).load($(window).bind("resize", checkPosition));
// function checkPosition(){
//    if($(window).width() >= 767){
//      var swiper = new Swiper(".itg_collection_list", {
//       spaceBetween: 0,
//       loop: false,
//       //freeMode: true,    
//       scrollbar: {
//         el: '.swiper-scrollbar1',
//         draggable: true,
//         dragSize: 100
//       },
//       breakpoints: {
//         768: {
//           slidesPerView: 2,         
//         },
//          480: {
//           slidesPerView: 1,
//         }
//       },
//     });
//    }
// }


//Show sahre data on product page 
$(document).on('click', '.itg_share_icon', function(){
  $('.itg_show_share_icon').toggleClass('open')
});

//Faq page search option
 $(document).on('change keyup paste', '.faqAccordianBanner_search input#search', function(){
    // console.log('key');
    var searchtermNF = $(this).val();
    var searchTerm = $(this).val().toUpperCase();
    // console.log(searchTerm);
    if ( searchTerm == "" ) {
      $('.faqAccordianError_message').hide();
      $('.itg_faq_accordion.itg_faq_heading').show();
      $('.itg_fqa_question').show();
      return;
    }
    $(".itg_fqa_question").each(function(){
      var accordianText = $(this).find('.itg_faq_data button.collapsible-trigger span.itg_accordion_title').text().toUpperCase();
      // console.log('accordian Text----' + accordianText)
      if  ( accordianText.indexOf(searchTerm) != -1) {
        $(this).show();
        $(this).addClass('searchMatched');
        $('.itg_faq_accordion.itg_faq_heading').hide();
        $('.itg_faq_accordion.itg_faq_heading:first').show();
      }else{
        $(this).hide();
        $(this).removeClass('searchMatched');
      }

      var MatchedLength = $('.itg_fqa_question.searchMatched').length;
      // console.log(MatchedLength)
      if(MatchedLength >= 1) {
        $('.faqAccordianError_message').hide();
      }else{
        $('.faqAccordianError_message span').text(searchtermNF);
        $('.faqAccordianError_message').show();
        $('.itg_faq_accordion.itg_faq_heading').hide();
      }
    });
  });






//custom cursor
// const cursor = document.querySelector('.cursor');

// document.addEventListener('mousemove', e => {
//     cursor.setAttribute("style", "top: " + (e.pageY - 10) + "px; left: " + (e.pageX - 10) + "px;")
// });

// document.addEventListener('click', e => {
//     cursor.classList.add("expand");
//     setTimeout(() => {
//         cursor.classList.remove("expand");
//     }, 500);
// });

let clientX = -100;
let clientY = -100;
const innerCursor = document.querySelector(".cursor--small");

const initCursor = () => {

  document.addEventListener("mousemove", e => {
    clientX = e.clientX;
    clientY = e.clientY;
  });
  
  
  // const render = () => {
  //   innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
    
  //   requestAnimationFrame(render);
  // };
  // requestAnimationFrame(render);
};

initCursor();
let lastX = 0;
let lastY = 0;
let isStuck = false;
let showCursor = false;
let group, stuckX, stuckY, fillOuterCursor;

const initCanvas = () => {
  const canvas = document.querySelector(".cursor--canvas");
  const shapeBounds = {
    width: 75,
    height: 75
  };
  paper.setup(canvas);
  const strokeColor = "rgba(0, 0, 0, 0.5)";
  const strokeWidth = 1;
  const segments = 8;
  //const radius = 25;
  const radius = 12;
  
  const noiseScale = 150; // speed
  const noiseRange = 4; // range of distortion
  let isNoisy = false; // state
  
  const polygon = new paper.Path.RegularPolygon(
    new paper.Point(0, 0),
    segments,
    radius
  );
  polygon.strokeColor = strokeColor;
  polygon.strokeWidth = strokeWidth;
  polygon.smooth();
  group = new paper.Group([polygon]);
  group.applyMatrix = false;
  
  const noiseObjects = polygon.segments.map(() => new SimplexNoise());
  let bigCoordinates = [];
  
  
  const lerp = (a, b, n) => {
    return (1 - n) * a + n * b;
  };
  const map = (value, in_min, in_max, out_min, out_max) => {
    return (
      ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  };
  
  paper.view.onFrame = event => {
   
    lastX = lerp(lastX, clientX, 0.2);
    lastY = lerp(lastY, clientY, 0.2);
    group.position = new paper.Point(lastX, lastY);
  }
}

// initCanvas();
const initHovers = () => {

  const handleMouseEnter = e => {
    const navItem = e.currentTarget;
    const navItemBox = navItem.getBoundingClientRect();
    stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
    stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
    isStuck = true;
  };
  
  const handleMouseLeave = () => {
    isStuck = false;
  };
  
  //Event listeners
  const linkItems = document.querySelectorAll(".link");
  linkItems.forEach(item => {
    item.addEventListener("mouseenter", handleMouseEnter);
    item.addEventListener("mouseleave", handleMouseLeave);
  });
};

initHovers();

//Find your size page 
  var opt1 = document.getElementById('option-1');
  var opt2 = document.getElementById('option-2');
  var dtImage = document.getElementById('dt-image')
  var mbImage = document.getElementById('mb-image')

  function toggleIn() {
    console.log(opt1.dataset.toggle);
    opt1.style.fontWeight = "600";
    opt2.style.fontWeight = "400";

    if ((window.innerWidth || document.documentElement.clientWidth) > 769) {
      dtImage.srcset = "https://cdn.shopify.com/s/files/1/1365/7915/files/size-chart-desktop.png?v=1663865318";
    } else {
      mbImage.srcset = 'https://cdn.shopify.com/s/files/1/1365/7915/files/size-chart-mobile.png?v=1663865332';

    }

  }


  function toggleCm() {
    opt2.style.fontWeight = "600";
    opt1.style.fontWeight = "400";
    if ((window.innerWidth || document.documentElement.clientWidth) > 769) {
      dtImage.srcset =
        'https://cdn.shopify.com/s/files/1/1365/7915/files/desktop-cm_9e9069a9-60b8-4614-aecd-b860d9ce04cc.png?v=1663875210';
    } else {
      mbImage.srcset = 'https://cdn.shopify.com/s/files/1/1365/7915/files/mobile_cm.png?v=1663873928';

    }

  }

// function searchDrawer() {
//   let searchIcon = document.querySelector(".search-mobile-filter");
//   let searchIcondesktop = document.querySelector(".desktop-search");
//   let mobileSearchdrawer = document.querySelector('.mobile-drawer-search');
//   let closeMobilesearch = document.querySelector('.close-wrapper-icon');
//   let bodyElement = document.body;
//   if (searchIcon && mobileSearchdrawer && bodyElement) {
//     searchIcon.addEventListener("click", function () {
//       mobileSearchdrawer.classList.add('active-drawer');
//       bodyElement.classList.add('overflow-hidden');
//     });
//   }
//   if(closeMobilesearch && mobileSearchdrawer && bodyElement){
//     closeMobilesearch.addEventListener("click", function () {
//       mobileSearchdrawer.classList.remove('active-drawer');
//       bodyElement.classList.remove('overflow-hidden');
//     });
//   }
//   if (searchIcondesktop && mobileSearchdrawer && bodyElement) {
//     searchIcondesktop.addEventListener("click", function () {
//       mobileSearchdrawer.classList.add('active-drawer');
//       bodyElement.classList.add('overflow-hidden');
//     });
//   }
// }
function searchDrawer() {
  let searchIcon = document.querySelector(".search-mobile-filter");
  let searchIconsDesktop = document.querySelectorAll(".desktop-search"); // multiple desktop icons
  let mobileSearchdrawer = document.querySelector('.mobile-drawer-search');
  let closeMobilesearch = document.querySelector('.close-wrapper-icon');
  let bodyElement = document.body;

  // Mobile search icon click
  if (searchIcon && mobileSearchdrawer && bodyElement) {
    searchIcon.addEventListener("click", function () {
      mobileSearchdrawer.classList.add('active-drawer');
      bodyElement.classList.add('overflow-hidden');
    });
  }

  // Close search drawer
  if (closeMobilesearch && mobileSearchdrawer && bodyElement) {
    closeMobilesearch.addEventListener("click", function () {
      mobileSearchdrawer.classList.remove('active-drawer');
      bodyElement.classList.remove('overflow-hidden');
    });
  }

  // Desktop search icons click (loop for all)
  if (searchIconsDesktop.length && mobileSearchdrawer && bodyElement) {
    searchIconsDesktop.forEach(function (icon) {
      icon.addEventListener("click", function () {
        mobileSearchdrawer.classList.add('active-drawer');
        bodyElement.classList.add('overflow-hidden');
      });
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  searchDrawer();
});

function my_code(){
  var a = document.querySelector('a[href="https://www.naniswimwear.com/products/coastal-hybrid-explorer-short?_pos=1&_psq=coastal-h&_ss=e&_v=1.0"]');
  if (a) {
    a.setAttribute('href', '/')
  }
}

window.addEventListener('load', function() {
  setTimeout(my_code, 1000);
});


      document.addEventListener("DOMContentLoaded", function () {
        const swimwearHeaders = document.querySelectorAll('.SiteHeaderMain');
        const lifestyleHeaders = document.querySelectorAll('.ctm-header');
        const tabs = document.querySelectorAll('.tab-btn');
        const announcementBar = document.querySelector('.announcement-bar');

        function showHeader(type) {
          if (type === "swimwear") {
            lifestyleHeaders.forEach(el => el.style.display = 'none');
            swimwearHeaders.forEach(el => el.style.display = '');
          } else if (type === "lifestyle") {
            swimwearHeaders.forEach(el => el.style.display = 'none');
            lifestyleHeaders.forEach(el => el.style.display = '');
          }

          // Update active tab visually
          tabs.forEach(tab => {
            if (tab.dataset.header === type) {
              tab.classList.add("is-active");
            } else {
              tab.classList.remove("is-active");
            }
          });

          // 🟡 Add class to announcement bar if lifestyle
          if (announcementBar) {
            if (type === "lifestyle") {
              announcementBar.classList.add("lifestyle-mode");
            } else {
              announcementBar.classList.remove("lifestyle-mode");
            }
          }
        }

        // Home page check
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
        const savedHeader = isHomePage ? "swimwear" : (localStorage.getItem("activeHeader") || "swimwear");

        // Header show only once during page load
        showHeader(savedHeader);

        // Tab click: only update localStorage and active class
        tabs.forEach(tab => {
          tab.addEventListener("click", function () {
            const selected = this.dataset.header;

            // Save selection but do not run showHeader()
            localStorage.setItem("activeHeader", selected);

            // Update active tab only
            tabs.forEach(t => t.classList.remove("is-active"));
            this.classList.add("is-active");

            // Do NOT call showHeader() here
          });
        });
      });


document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.desktop-search');
  if (!trigger) return;

  var activated = false;

  trigger.addEventListener('click', function () {
    if (activated) return;
    activated = true;

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      // Fade-in once image is loaded
      img.addEventListener('load', function onLoad() {
        img.classList.add('loaded');
        img.removeEventListener('load', onLoad);
      });

      // Restore responsive attributes
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }

      // Restore src
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  });
});